"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyGridElement = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const react_1 = tslib_1.__importDefault(require("react"));
const CenteredMessage_1 = require("../CenteredMessage");
const StyleFunctions_1 = require("../style/StyleFunctions");
const emptyGridContainerClass = (0, StyleFunctions_1.cssClass)('emptyGridContainer', {
    height: '100%',
});
function EmptyGridElement(props) {
    return (react_1.default.createElement(vizportalclient_common_components_1.HorizontalFlexContainer, { "data-tb-test-id": 'empty-grid', additionalClassNames: [emptyGridContainerClass] },
        react_1.default.createElement(CenteredMessage_1.CenteredMessage, { message: props.emptyGridMessage || catalog_messages_1.Messages.EmptyContentMessage() })));
}
exports.EmptyGridElement = EmptyGridElement;
//# sourceMappingURL=EmptyGridElement.js.map